import { useRef } from 'react'
import { useToast } from '@/hooks/useToast'
import { useTheme } from 'next-themes'
import * as htmlToImage from 'html-to-image'

export function useImageDownload() {
  const { toast } = useToast()
  const cardRef = useRef<HTMLDivElement>(null)
  const { theme: currentTheme } = useTheme()

  const handleDownload = async (title: string) => {
    if (cardRef.current === null) return

    try {
      const dataUrl = await htmlToImage.toPng(cardRef.current, {
        quality: 1.0,
        backgroundColor: currentTheme === 'dark' ? '#09090B' : '#ffffff',
        style: {
          color: currentTheme === 'dark' ? '#ffffff' : '#09090B',
        }
      })
      
      const link = document.createElement('a')
      link.download = `${title.toLowerCase().replace(/\s+/g, '-')}.png`
      link.href = dataUrl
      link.click()

      toast({
        title: "Image downloaded!",
        description: "Card image has been saved to your device.",
        duration: 2000,
      })
    } catch (err) {
      toast({
        title: "Failed to download image",
        description: "Please try again",
        variant: "destructive",
      })
    }
  }

  return { handleDownload, cardRef }
} 